import React from 'react';

function DebugPanel({ startTime, clickTracker }) {
  return (
    <div style={{ display: 'absolute', top: '0', left: '0' }}>
      <div className="d-flex flex-column">
        <div>
          <h3>
            start: <u>{startTime}</u>
          </h3>
        </div>
        <div>
          Clicks:
          <ul>
            {clickTracker.map((click) => (
              <li key={click.time}>{`${click.id} at ${click.time}`}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default DebugPanel;
